/* OSManagementConstants.js */

"use strict";

/**
 * @typedef [Object<label, value>] CATALOG_USAGE - User selectable values for the Catalog Usage dropdown
 **/

const CATALOG_USAGE = [
    {
        label: "Required for all users",
        value: "REQUIRED"
    },
    {
        label: "Optional for all users",
        value: "OPTIONAL"
    },
    {
        label: "Required for all subordinate roles",
        value: "SUBORDINATES"
    }
];

const DEFAULT_PORTS = {
    FTP: 21,
    HOST: 2022,
    SCP: 22,
    TFTP: 69
};

const SSH_KEX_ALGO = [
    "diffie-hellman-group1-sha1",
    "diffie-hellman-group14-sha1",
    "diffie-hellman-group14-sha256", 
    "diffie-hellman-group16-sha512", 
    "diffie-hellman-group18-sha512", 
    "diffie-hellman-group-exchange-sha1",
    "diffie-hellman-group-exchange-sha256", 
    "ecdh-sha2-nistp256",
    "ecdh-sha2-nistp384",
    "ecdh-sha2-nistp521",
    "curve25519-sha256",
    "curve25519-sha256@libssh.org",
    "sntrup4591761x25519-sha512@tinyssh.org"
];

const SSH_KEX_DEF = [
    "diffie-hellman-group14-sha256",
    "diffie-hellman-group16-sha512",
    "diffie-hellman-group18-sha512",
    "diffie-hellman-group-exchange-sha256",
    "curve25519-sha256@libssh.org"
];

const SSH_CIPHERS = [
    "3des-cbc",
    "aes128-cbc",
    "aes192-cbc",
    "aes256-cbc",
    "rijndael-cbc@lysator.liu.se",
    "aes128-ctr",
    "aes192-ctr",
    "aes256-ctr",
    "aes128-gcm@openssh.com",
    "aes256-gcm@openssh.com",
    "chacha20-poly1305@openssh.com"
];

const SSH_CIPHER_DEF = [
    "aes128-ctr",
    "aes192-ctr",
    "aes256-ctr",
    "aes128-gcm@openssh.com",
    "aes256-gcm@openssh.com",
    "chacha20-poly1305@openssh.com"
];

const SSH_MACS = [
    "hmac-sha1",
    "hmac-sha1-96",
    "hmac-sha2-256",
    "hmac-sha2-512",
    "hmac-md5",
    "hmac-md5-96",
    "umac-64@openssh.com",
    "umac-128@openssh.com",
    "hmac-sha1-etm@openssh.com",
    "hmac-sha1-96-etm@openssh.com",
    "hmac-sha2-256-etm@openssh.com",
    "hmac-sha2-512-etm@openssh.com",
    "hmac-md5-etm@openssh.com",
    "hmac-md5-96-etm@openssh.com",
    "umac-64-etm@openssh.com",
    "umac-128-etm@openssh.com"
];

const SSH_MAC_DEF = [
    "hmac-sha2-256-etm@openssh.com",
    "hmac-sha2-512-etm@openssh.com",
    "umac-128-etm@openssh.com"
];

module.exports = {
    CATALOG_USAGE,
    DEFAULT_PORTS,
    SSH_KEX_ALGO,
    SSH_KEX_DEF,
    SSH_CIPHERS,
    SSH_CIPHER_DEF,
    SSH_MACS,
    SSH_MAC_DEF
};
